<template>
    <div>
        <el-dialog
            :title="dialogFormTitle"
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            width="30%"
            :center="true"
            top="20vh"
            :close-on-click-modal="false"
            :before-close="() => closeDialog()"
            v-loading.fullscreen.lock="login_loading"
        >
            <div>
                <el-form
                    :model="form"
                    :rules="rules"
                    ref="carPartEditForm"
                    label-width="100px"
                    size="small"
                >
                    <div v-if="show_type">
                        <el-form-item label="清单名称" prop="name">
                            <el-input
                                v-model="form.name"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="零件号" prop="batch_number">
                            <el-input
                                v-model="form.batch_number"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="托盘号" prop="specifications">
                            <el-input
                                v-model="form.specifications"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div v-else>
                        <el-descriptions
                            class="margin-top"
                            :column="1"
                            :labelStyle="{'width':'120px','text-align':'center'}"
                            :contentStyle="{'text-align': 'center'}"
                            border
                        >
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>清单名称</span>
                                </template>
                                <span>{{form.name}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>零件号</span>
                                </template>
                                <span>{{form.batch_number}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>托盘号</span>
                                </template>
                                <span>{{form.specifications}}</span>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <div v-if="show_type===0">
                    <el-button
                        v-if="$_has(edit_auth)"
                        type="primary"
                        plain
                        @click="$emit('show_edit')"
                        >修改</el-button
                    >
                    <el-button
                        v-if="$_has(del_auth) && form.state===0"
                        type="danger"
                        plain
                        @click="carPartDel()"
                        >删除</el-button
                    >
                    <el-button
                        plain
                        @click="closeDialog()"
                        >关闭</el-button
                    >
                </div>
                <div v-else-if="show_type===1">
                    <el-button
                        type="success"
                        plain
                        @click="submitInsert('carPartEditForm')"
                        >确定</el-button
                    >
                    <el-button
                        type="warning"
                        plain
                        @click="resetForm('carPartEditForm')"
                        >重置</el-button
                    >
                    <el-button
                        plain
                        @click="closeDialog()"
                        >关闭</el-button
                    >
                </div>
                <div v-else>
                    <el-button
                        type="success"
                        plain
                        @click="submitEdit('carPartEditForm')"
                        >确定修改</el-button
                    >
                    <el-button
                        plain
                        @click="closeDialog()"
                        >取消操作</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { car_part_add_request,car_part_del_request,car_part_edit_request } from '@/network/WareHouse/CarPart.js'

export default {
    name: 'CarPartEditBarComponent',
    data() {
        return {
            login_loading: false,
            form: {
                name: '',
                batch_number: '',
                specifications: ''
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请输入清单名称',
                        trigger: 'blur',
                    }
                ],
                batch_number: [
                    {
                        required: true,
                        message: '请输入零件号',
                        trigger: 'blur',
                    }
                ],
                specifications: [
                    {
                        required: true,
                        message: '请输入托盘号',
                        trigger: 'blur',
                    }
                ]
            },
        }
    },
    computed: {
        dialogFormTitle() {
            if(this.show_type === 0) {
                return '装箱清单详情'
            } else if (this.show_type === 1) {
                return '添加装箱清单'
            } else {
                return '修改装箱清单'
            }
        },
    },
    methods: {
        closeDialog() {
            this.form.name = ''
            this.form.batch_number = ''
            this.form.specifications = ''
            this.$emit('exitDialog')
        },
        submitInsert(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.carPartInsert()
            })
        },
        carPartInsert() {
            this.login_loading = true
            car_part_add_request(this.form)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('添加成功!')
                        this.$emit('exitDialog')
                        this.$emit('search')
                        this.$emit('details_row',s.result.id*1)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
        },
        submitEdit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.car_part_edit(formName)
            })
        },
        car_part_edit() {
            this.login_loading = true
            this.form.id = this.id
            car_part_edit_request(this.form)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('修改成功!')
                        this.$emit('exitDialog')
                        this.$emit('search')
                        this.$emit('details_row',this.form.id)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        carPartDel() {
            this.$confirm(
                '是否确定删除？（一经删除，将无法再进行恢复，请谨慎操作！）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    car_part_del_request(this.id)
                        .then((s) => {
                            if (s.status === 0) {
                                this.$message.success('删除成功!')
                                this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.$message.error(err)
                        })
                        .finally(() => this.closeDialog())
                })
                .catch((err) => {})
        },
    },
    filters: {},
    props: {
        dialogFormVisible: Boolean,
        id: {
            type: Number,
            default() {
                return 0
            },
        },
        car_part_details_data: {
            type: Object,
            default() {
                return {}
            },
        },
        show_type: {
            type:Number,
            default() {
                return 0
            },
        },
        edit_auth: String,
        del_auth: String
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {
        car_part_details_data(newVal) {
            this.form = newVal
        },
    },
}
</script>

<style>
</style>